import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBlock from '../../Core/TitleBlock';
import PageLayout from '../../Core/PageLayout';
import TimeOffIcon from '../../Icons/TimeOff';
import TitleBackIcon from '../../Icons/TitleBackIcon';
import RequestBehalf from '../../Core/Dialog/RequestBehalf';
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { useSelector } from 'react-redux';
import { settingWorkTime } from '../../../store/settings/selectors'
import usePermissions from '../../Core/usePermissions';
import { userSelector } from '../../../store/auth/selectors'
import Dialog from '@material-ui/core/Dialog'

import classes from './timeoff.module.scss';
import Button from '../../Core/Button/Button';
import classsnames from 'classnames';
import EditIconFixedFill from '../../Icons/EditIconFixedFill';
import CheckIcon from '../../Icons/CheckIcon';
import RejectIcon from '../../Icons/RejectIcon';

import TimeOffSymbol1 from '../../Icons/TimeOffSymbol1';
import TimeOffSymbol2 from '../../Icons/TimeOffSymbol2';
import TimeOffSymbol3 from '../../Icons/TimeOffSymbol3';
import TimeOffSymbol4 from '../../Icons/TimeOffSymbol4';
import TimeOffSymbol5 from '../../Icons/TimeOffSymbol5';
import TimeOffSymbol6 from '../../Icons/TimeOffSymbol6';
import TimeOffSymbol7 from '../../Icons/TimeOffSymbol7';
import TimeOffSymbol8 from '../../Icons/TimeOffSymbol8';
import TimeOffSymbol9 from '../../Icons/TimeOffSymbol9';
import DescriptionIcon from '../../Icons/DescriptionIcon';
import GrownuSystemAvatar from '../../Icons/GrownuSystemAvatar'
import GrownuAdminAvatar from '../../Icons/GrownuAdminAvatar'
import PaperClipIcon from '../../Icons/PaperClip'
import UploadFiles from '../../UploadFiles'
import avatar from '../../Icons/avatar.png';

import {Tooltip as ReactTooltip} from 'react-tooltip';
import PoliciesActivityTable from './TimeOffDetails/PoliciesActivityTable';

const moment = extendMoment(Moment)

const permissionsConfig = [
  {
    name: 'time_off_fill_request_behalf',
    permission: 'time_off_fill_request_behalf',
    module: 'time_off',
  }, { name: 'app_manager', permission: 'app_manager' },
];

const convertFormat = (companyFormat) => {
  const keyMap = {
    'DD': 'DD',
    'MM': 'MM',
    'YY': 'YYYY',
  }
  return companyFormat.split('.').map(k => keyMap[k] || k).join('-')
}

function EmployeeManagement({
  goEmployeeActivity,
  onUnassingPolicyEmployees,
  handleClose,
  activeTimeOff,
  activePolicy,
  employee,
  policies,
  requestBehalf,
  onRequestBehalf,
  onChangeRequestStatus = Function.prototype,
}) {
  const { t } = useTranslation();
  const permissions = usePermissions(permissionsConfig);
  const workTime = useSelector(settingWorkTime);
  const companyData = useSelector(state => state.company.companyInfo);
  const user = useSelector(userSelector)

  const uploadFilesRef = useRef(null)

  const [requestBehalfOpen, setRequestBehalfOpen] = useState(false);
  const [requestBehalfEditOpen, setRequestBehalfEditOpen] = useState(null);
  const [showDocuments, setShowDocuments] = useState(false)
  const requests = Array.isArray(requestBehalf) ? requestBehalf : [];

  const isManager = permissions.app_manager

  const holidaysMap = [...(workTime?.work_time?.holidays || []), ...(workTime?.national_holidays || [])].reduce((acc, holiday) => ({
    ...acc,
    [holiday.date]: true,
  }), {})

  const policiesMap = policies.reduce((acc, policy) => ({
    ...acc,
    [policy.id]: policy,
  }), {})

  const handleOpenDocuments = (documents) => () => {
    setShowDocuments(true)
    setTimeout(() => {
      uploadFilesRef.current.setFiles(documents)
    }, 300)
  }

  const renderApproverAvatar = (request) => {
    const { rejected_by, approver_1_name, approver_1_avatar, approver_2_name, approver_2_avatar } = request
    const avatars = []
    if (request.status === 'rejected' && rejected_by) {
      avatars.push({
        image: rejected_by === 'Super Admin' ? <GrownuAdminAvatar /> : <img src={request.rejected_by_avatar || avatar} alt='approver' className={classes.approverAvatar} />,
        label: rejected_by === 'Super Admin' ? t('Grownu support') : request.rejected_by_name,
      })
      return avatars
    }
    if (!approver_1_name && !approver_2_name) {
      avatars.push({
        image: <GrownuSystemAvatar />,
        label: t('Grownu support'),
      })
      return avatars
    }
    if (approver_1_name) {
      const avatar1 = {
        image: approver_1_name === 'Super Admin' ? <GrownuAdminAvatar /> : <img src={approver_1_avatar || avatar} alt='approver1' className={classes.approverAvatar} />,
        label: approver_1_name === 'Super Admin' ? t('Grownu support') : approver_1_name,
      }
      avatars.push(avatar1)
    }
    if (approver_2_name) {
      const avatar2 = {
        image: approver_2_name === 'Super Admin' ? <GrownuAdminAvatar /> : <img src={approver_2_avatar || avatar} alt='approver2' className={classes.approverAvatar} />,
        label: approver_2_name === 'Super Admin' ? t('Grownu support') : approver_2_name,
      }
      avatars.push(avatar2)
    }
    return avatars
  }

  return (
    <>
      <TitleBlock title={`${activeTimeOff?.name ? `${activeTimeOff.name} / ` : ''} ${activePolicy?.name ? `${activePolicy.name} / ` : ''} ${employee.name} ${employee.surname}`}>
        <TimeOffIcon viewBox='0 0 26 26' fill='rgba(226,235,244,0.85)' />
        <div
          className={classes.titleBackButton}
          onClick={handleClose}
          data-tooltip-html={t('Back')} data-tooltip-id='back_button'
        >
          <div>
            <TitleBackIcon />
          </div>
        </div>
      </TitleBlock>
      <PageLayout>
        <div className={classes.container}>
          <div className={classes.containerTitle}>
            {t('Employee')}
          </div>
          <div className={classes.employeeBlock}>
            {
              employee.photo && (
                <div className={classes.avatarBlock}>
                  <img
                    src={employee.photo}
                    alt='avatar'
                    className={classes.avatar}
                  />
                </div>
              )
            }
            <div>
              <div className={classes.employeeName}>{employee.name} {employee.surname}</div>
              <div className={classes.skillName}>{employee.skills}</div>
            </div>

            { permissions.time_off_fill_request_behalf ?
                <div className={classes.buttonBlock}>
                  <Button
                    className={classes.button}
                    size="large"
                    primary
                    onClick={() => {
                      setRequestBehalfOpen(true);
                    }}
                  >
                    {t('Request on behalf')}
                  </Button>
                </div>
              : null
            }
          </div>
        </div>
        {
          requests.length > 0
            ? <div className={classes.container}>
                <div className={classes.containerTitle}>
                  {t('Upcoming requests')} <span style={{color: '#808F94'}}>{requests.length}</span>
                </div>
                {
                  requests.length > 0 ? (
                    <div className={classes.upcomingRequests}>
                      <div className={classes.upcomingRequestsHeader}>
                        <div className={classes.upcomingRequestsHeaderCol}>
                          {t('Request type')}
                        </div>
                        <div className={classes.upcomingRequestsHeaderCol}>
                          {t('Days')}
                        </div>
                        <div className={classes.upcomingRequestsHeaderCol}>
                          {t('When')}
                        </div>
                        <div className={classes.upcomingRequestsHeaderCol}>
                          {t('Requested on')}
                        </div>
                        <div className={classes.upcomingRequestsHeaderCol}>
                          {t('Status')}
                        </div>
                        <div className={classes.upcomingRequestsHeaderCol}></div>
                      </div>
                      {requests.map((request) => {
                        const policy = policiesMap[request.policy_id] || {};
                        const range = Array.from(moment.range(moment(request.from), moment(request.to)).by('days')).map(date => date.format('YYYY-MM-DD'))
                        const totalWorkingDays = range.reduce((acc, date) => {
                          if (holidaysMap[date]) {
                            return acc
                          }
                          const day = moment(date).day()
                          if (activeTimeOff.work_days === 'any_day' || (day !== 0 && day !== 6)) {
                            return acc + 1
                          }
                          return acc
                        }, 0)

                        const isApprover = (isManager && !request.approver_1_id && !request.approver_2_id || (request.approver_1_id === user.employee?.id || request.approver_2_id === user.employee?.id))
                        const isSelfRequest = request.employee_id === user.employee?.id
                        const isCanApproveSelfRequest = !policy.prevent_self_approval && isApprover
                        const canApprove = isSelfRequest ? isCanApproveSelfRequest : isApprover

                        return (
                          <div key={request.id} className={classes.upcomingRequestsRow}>
                            <div className={classes.upcomingRequestsCol}>
                              <span className={classes.tableSymbol} style={{ backgroundColor: policy.color }}>
                                {policy.symbol === '1' && <TimeOffSymbol1 />}
                                {policy.symbol === '2' && <TimeOffSymbol2 />}
                                {policy.symbol === '3' && <TimeOffSymbol3 />}
                                {policy.symbol === '4' && <TimeOffSymbol4 />}
                                {policy.symbol === '5' && <TimeOffSymbol5 />}
                                {policy.symbol === '6' && <TimeOffSymbol6 />}
                                {policy.symbol === '7' && <TimeOffSymbol7 />}
                                {policy.symbol === '8' && <TimeOffSymbol8 />}
                                {policy.symbol === '9' && <TimeOffSymbol9 />}
                              </span>
                              {request.policy_name}
                              {
                                request.note
                                  ? <div className={classes.note} data-tooltip-html={request.note} data-tooltip-id='note'>
                                      <DescriptionIcon />
                                    </div>
                                  : null
                              }
                              {
                                request.documents?.length
                                  ? <div className={classes.documentsIcon} onClick={handleOpenDocuments(request.documents)}>
                                      <PaperClipIcon />
                                    </div>
                                  : null
                              }
                            </div>
                            <div className={classes.upcomingRequestsCol}>
                              {totalWorkingDays}
                            </div>
                            <div className={classes.upcomingRequestsCol}>
                              {moment(request.from).format(convertFormat(companyData.date_format))} - {moment(request.to).format(convertFormat(companyData.date_format))}
                            </div>
                            <div className={classes.upcomingRequestsCol}>
                              {moment(request.created_at).format(convertFormat(companyData.date_format))}
                            </div>
                            <div className={classsnames(classes.upcomingRequestsCol, classes.status)}>
                              { renderApproverAvatar(request).map((avatar, i) => {
                                return (
                                  <div key={i} data-tooltip-html={avatar.label} data-tooltip-id='emp_name'>{avatar.image}</div>
                                )
                              }) }
                              <div className={classsnames(classes.upcomingRequestsStatus, {
                                [classes.requestStatusApproved]: request.status === 'approved',
                                [classes.requestStatusPending]: request.status === 'pending',
                                [classes.requestStatusRejected]: request.status === 'rejected',
                                [classes.requestStatusCancelled]: request.status === 'cancelled',
                              })}>
                                {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                              </div>
                            </div>
                            <div className={classes.upcomingRequestsCol}>
                              <div className={classes.upcomingRequestsButtons}>
                                <div data-tooltip-html={t("Edit")} data-tooltip-id="tip_request">
                                  <Button
                                    className={classes.buttonEdit}
                                    size="little"
                                    onClick={() => {
                                      setRequestBehalfEditOpen(request)
                                    }}
                                  >
                                    <EditIconFixedFill />
                                  </Button>
                                </div>
                                { request.status !== 'approved' && canApprove && (
                                  <div data-tooltip-html={t("Approve")} data-tooltip-id="tip_request">
                                    <Button
                                      className={classes.buttonApprove}
                                      size="little"
                                      onClick={() => {onChangeRequestStatus(request.id, 'approved')}}
                                    >
                                      <CheckIcon />
                                    </Button>
                                  </div>
                                )}
                                { request.status !== 'rejected' && canApprove && (
                                  <div data-tooltip-html={t("Reject")} data-tooltip-id="tip_request">
                                    <Button
                                      className={classes.buttonReject}
                                      size="little"
                                      onClick={() => {onChangeRequestStatus(request.id, 'rejected')}}
                                    >
                                      <RejectIcon />
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      })}
                      </div>
                  ) : null
                }   
              </div>
            : null
        }
        <PoliciesActivityTable
          goEmployeeActivity={goEmployeeActivity}
          onUnassingPolicyEmployees={onUnassingPolicyEmployees}
          employee={employee}
        />
      </PageLayout>
      <RequestBehalf
        open={!!(requestBehalfOpen || requestBehalfEditOpen)}
        handleClose={() => {
          setRequestBehalfOpen(false);
          setRequestBehalfEditOpen(null);
        }}
        title={t('Request on behalf')}
        onSubmit={(data) => {
          onRequestBehalf(data, requestBehalfEditOpen?.id);
          setRequestBehalfOpen(false);
          setRequestBehalfEditOpen(null);
        }}
        buttonTitle={t('Submit')}
        employees={[employee]}
        policies={policies}
        initialValue={{...(activePolicy ? {policy_id: activePolicy.id} : {}), ...requestBehalfEditOpen}}
        activeTimeOff={activeTimeOff}
        singleRequest
      />
      <Dialog
        open={showDocuments}
        onClose={() => setShowDocuments(false)}
        >
        <div className={classes.dialogContent}>
          <div>{t('Attachment')}</div>
          <UploadFiles mode="view" ref={uploadFilesRef} />
        </div>
      </Dialog>
      <ReactTooltip
        id='note'
        effect='solid'
        className={classes.tooltip}
      />
      <ReactTooltip
        id='back_button'
        effect='solid'
        className={classes.tooltip_back}
      />
      <ReactTooltip
        id='tip_request'
        effect='solid'
        className={classes.tooltip_back}
      />
      <ReactTooltip
        id='emp_name'
        effect='solid'
        opacity={1}
        className={classes.tooltip_emp}
      />
    </>
  );
}

export default EmployeeManagement;